import Http from '../http'

export default {

  index(filter) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/companies`, {params: {...filter}})
  },

  create(company){
    return Http.post(`/companies`, {company: {
      ...company,
    }})
  },

  update(company){
    return Http.put(`/companies/${company.id}`, {
      company: {
        ...company,
      },
    });
  },

  show(id) {
    return Http.get(`/companies/${id}`);
  },

  showClientLastOrder(filter = {}) {
    return Http.get(`/company_last_orders`, {params: {...filter}});
  },

  delete(){
    // return Http.delete(`/action_plans/${id}`)
  }
}